// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery-modal-component {\n  left: 60px !important;\n  top: 25px !important;\n}\n.gallery-modal-button {\n  width: 160px;\n}\n", ""]);
// Exports
module.exports = exports;
